<template>
    <a-card>
        <div style="position:relative">
            <a-steps class="stepsTop" :current="current">
                <a-step :class="{ changeFlex: current == 0 }" @click="current = 0; goAnchor('#current0');" title="项目基本信息" />
                <a-step :class="{ changeFlex: current == 1 }" @click="current = 1; goAnchor('#current1');" title="单位基本信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 2 }"
                    @click="current = 2; goAnchor('#current2');" title="分阶段具体实施目标" />
                <a-step v-if="projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 3 }"
                    @click="current = 3; goAnchor('#current3');" title="项目规模、指标和验收内容" />
                <a-step v-if="projectTypeShow == 3" :class="{ sortFlex: current == 4 }" @click="current = 4; goAnchor('#current4');"
                    title="预期目标" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2" :class="{ sortFlex: current == 5 }"
                    @click="current = 5; goAnchor('#current5');" title="报告正文" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 0 || projectTypeShow == 2 || projectTypeShow == 3"
                    :class="{ changeFlex: current == 6 }" @click="current = 6; goAnchor('#current6');" title="项目负责人信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ changeFlex: current == 7 }"
                    @click="current = 7; goAnchor('#current7');" title="研究人员信息" />
                <a-step v-if="projectTypeShow == 2 || projectTypeShow == 3" :class="{ changeFlex: current == 8 }"
                    @click="current = 8; goAnchor('#current8');" title="合作单位信息" />
                <a-step v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" :class="{ langFlex: current == 9 }"
                    @click="current = 9; goAnchor('#current9');" title="项目经费预算情况" />
                <a-step :class="{ sortFlex: current == 10 }" @click="current = 10; goAnchor('#current10');" title="相关附件" />
            </a-steps>
            <div class="body-con">
                <!-- 项目基本信息 -->
                <projectBasicsInfoMain ref="projectBasicsInfoMain" id="current0" />
                <div v-if="projectIdShow" class="eltabs">
                    <div id="current1">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 单位基本信息 -->
                        <projectUnit ref="projectUnit" />
                    </div>
                    <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current2">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 分阶段具体实施目标 -->
                        <projectImplementation ref="projectImplementation" />
                    </div>
                    <div v-if="projectTypeShow == 2 || projectTypeShow == 3" id="current3">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 项目规模、指标和验收内容 -->
                        <projectCheck ref="projectCheck" />
                    </div>
                    <div v-if="projectTypeShow == 3" id="current4">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 预期目标 -->
                        <projectExpectations ref="projectExpectations" />
                    </div>
                    <div v-if="projectTypeShow == 1 || projectTypeShow == 2" id="current5">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 报告正文 -->
                        <projectReporttext ref="projectReporttext" />
                    </div>
                    <div v-if="projectTypeShow == 1 || projectTypeShow == 0 || projectTypeShow == 2 || projectTypeShow == 3"
                        id="current6">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 项目负责人信息 -->
                        <projectLeader ref="projectLeader" />
                    </div>
                    <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current7">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 研究人员信息 -->
                        <projectResearchers ref="projectResearchers" />
                    </div>
                    <div v-if="projectTypeShow == 2 || projectTypeShow == 3" id="current8">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 合作单位信息 -->
                        <projectCooperative ref="projectCooperative" />
                    </div>
                    <div v-if="projectTypeShow == 1 || projectTypeShow == 2 || projectTypeShow == 3" id="current9">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 项目经费预算情况 -->
                        <projectFundRecord ref="projectFundRecord" />
                    </div>
                    <div id="current10">
                        <a-divider class="currentitem" style="background-color: #bbb" dashed />
                        <!-- 相关附件 -->
                        <projectAnnex ref="projectAnnex" />
                    </div>
                </div>
            </div>
            <div class="bottom_submit">
                <a-divider id="current11" style="background-color: #dfdfdf" dashed />
                <a-button type="primary" @click="goBack(0)">
                    保存
                </a-button>
                <a-divider type="vertical"/>
                <a-button @click="$router.push({path:'/sys/TechnologieprojekteApply'})">
                    返回
                </a-button>
<!--                <a-button type="primary" style="margin-left:20px" @click="goBack(1)">
                    保存并提交
                </a-button>-->
            </div>
        </div>
    </a-card>
</template>
<script>
import projectBasicsInfoMain from "./components/projectBasicsInfo";
import projectUnit from "./components/projectUnit";
import projectImplementation from "./components/projectImplementation";
import projectReporttext from "./components/projectReporttext";
import projectLeader from "./components/projectLeader";
import projectResearchers from "./components/projectResearchers";
import projectFundRecord from "./components/projectFundRecord";
import projectAnnex from "./components/projectAnnex";
import projectCheck from "./components/projectCheck";
import projectCooperative from "./components/projectCooperative";
import projectExpectations from "./components/projectExpectations";
import { projectBasicsInfo } from "@/api/TechnologieprojekteApply";

import store from '@/store';

export default {
    name: "AddOrEditModal",
    components: {
        projectBasicsInfoMain,
        projectUnit,
        projectImplementation,
        projectReporttext,
        projectLeader,
        projectResearchers,
        projectFundRecord,
        projectAnnex,
        projectCheck,
        projectCooperative,
        projectExpectations,
    },

    data() {
        return {
            showData: false,
            current: 0,
            isModal: true,//是否是弹窗
            visible1: false,//弹窗是否显示
            classification: null,
            projectIdShow: false,
            projectTypeShow: null,
            projectId: null,
            options: [],
            navIndex: [],
            errorOut: 0,

        }
    },

    computed: {
    },
    mounted() {
        window.postData = this.postData;
        window.errorSet = this.errorSet;
        window.successSet = this.successSet;

        window.addEventListener('scroll', this.onScroll, true)
    },
    destroy() {
        // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        errorSet() {
            ++this.errorOut
        },
        onScroll() {
            // 获取所有锚点元素
            const navContents = document.querySelectorAll('.currentitem')
            // 所有锚点元素的 offsetTop
            const offsetTopArr = []
            navContents.forEach(item => {
                offsetTopArr.push(item.offsetTop)
            })

            // 获取当前文档流的 scrollTop
            var scrollTop = document.querySelector(".body-con").scrollTop + 307;
            this.navIndex = offsetTopArr.map((item, key) => {
                if (scrollTop >= item) {
                    return key
                }
            })
            for (let index = 0; index < this.navIndex.length; index++) {
                if (this.navIndex[index] == undefined) {
                    this.current = index
                    return index;
                }

            }
        },
        goBack(e) {
            this.errorOut = 0
            if (e) {
                if (this.projectIdShow) {
                    this.$refs.projectBasicsInfoMain.onSubmit()
                    this.$refs.projectUnit.onSubmit()
                    this.$refs.projectReporttext.onSubmit()
                    this.$refs.projectFundRecord.parentSave()
                    this.$refs.projectAnnex.onSubmit()

                } else {
                    this.$refs.projectBasicsInfoMain.onSubmit()
                }
                setTimeout(() => {

                    if (this.errorOut) {
                        this.$message.error("请检查所填项")
                    } else {
                        this.submit(store.getters.TechnologieTypeId.projectId)
                        // this.$router.push('/sys/TechnologieprojekteApply')
                    }
                }, 50);
            } else {
                if (this.projectIdShow) {
                    this.$refs.projectBasicsInfoMain.onSubmit()
                    this.$refs.projectUnit.onSubmit()
                    this.$refs.projectReporttext.onSubmit()
                    this.$refs.projectFundRecord.parentSave()
                    this.$refs.projectAnnex.onSubmit()
                } else {
                    this.$refs.projectBasicsInfoMain.onSubmit()
                }
                setTimeout(() => {

                    if (this.errorOut) {
                        this.$message.error("请检查所填项")
                    } else {
                        this.$router.push('/sys/TechnologieprojekteApply')
                    }
                }, 50);

            }
        },
        submit(record) {
            this.postAction({
                url: projectBasicsInfo.submit,
                params: {
                    id: record,
                    isSubmit: 1
                }
            }).then(() => {
                this.$message.success("提交成功！")
                this.$router.push('/sys/TechnologieprojekteApply')
            })
        },

        goAnchor(selector) {/*参数selector是id选择器（#anchor14）*/
            document.querySelector(selector).scrollIntoView({
                behavior: "smooth"
            });
        },
        postData(e, m) {
            this.classification = e
            this.projectId = m

            var list = {
                classification: e,
                projectId: m,
            }
            store.commit('TechnologieTypeId', list);
            this.projectTypeShow = this.$route.query.oneClassification
            console.log('当前大类', this.projectTypeShow)
            this.projectIdShow = true
        },
        onClose() {
            this.visible1 = false
        }
    },
}
</script>
<style lang="less" scoped>
.bottom_submit{
    //position: absolute;
    background: #fff;
    width: 100%;
    //bottom: 0.1vh;
}
.changeFlex {
    flex: 2;
}

.langFlex {
    flex: 3;
}

.sortFlex {
    flex: 1.3;
}

.stepsTop {
    cursor: pointer;
    width: 910px;
    height: 75px;
    z-index: 999;
    padding-top: 30px;
    padding-left: 24px;
    padding-right: 80px;
    background: #ffffff;
    margin-top: -20px;
    margin-left: -20px;
}

.body-con {
    overflow: auto;
    overflow-x: hidden;
    height: 600px;
}

/* 定位滚动条本身 */
::-webkit-scrollbar {
    width: 5px;
}

/* 定位滚动条的轨道部分 */
::-webkit-scrollbar-track {
    background-color: #f1f1f1;
}

/* 定位滚动条的滑块部分 */
::-webkit-scrollbar-thumb {
    background-color: #00aeff;
    border-radius: 5px;
}

/* 定位滚动条的按钮部分 */
::-webkit-scrollbar-button {
    display: none;
}

/* 定位滚动条的角落部分 */
::-webkit-scrollbar-corner {
    background-color: #f1f1f1;
}

:deep(.ant-modal-body) {
    height: 100vh !important;
    max-height: 100vh !important;
}</style>
